import { Method, RawAxiosRequestHeaders } from "axios";

import { axiosInstance } from "../model";

export const handleFetch = async <T, RT>(args: {
  url: string;
  method: Method;
  data?: T;
  headers?: RawAxiosRequestHeaders;
}): Promise<RT> => {
  const { method, url, headers, data } = args;
  try {
    const response = await axiosInstance({
      method,
      url,
      data,
      headers,
    });
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    if (error?.response?.data?.error) {
      return error?.response?.data;
    }

    throw new Error(error);
  }
};
